import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, ExternalLink, Calendar, ShoppingBag, Home, MessageCircle, Mail } from "lucide-react";
import LionLogo from "../components/LionLogo";

const LINKS = [
  { to: "/book-reading", label: "Book a Reading", icon: Calendar, internal: true },
  { to: "/shop", label: "Shop Products", icon: ShoppingBag, internal: true },
  { to: "/services", label: "Spiritual Consultations", icon: MessageCircle, internal: true },
  { to: "/house-calls", label: "Request a House Call", icon: Home, internal: true },
  { to: "/contact", label: "Contact The Lion Chief", icon: Mail, internal: true },
  { to: "https://www.instagram.com/lyonsdenprotection", label: "Instagram", icon: Instagram, internal: false },
  { to: "https://www.facebook.com/lyonsdenprotection", label: "Facebook", icon: Facebook, internal: false },
  { to: "https://www.tiktok.com/@lyonsdenprotection", label: "TikTok", icon: ExternalLink, internal: false },
  { to: "https://www.youtube.com/@LyonsDenProtection", label: "YouTube", icon: Youtube, internal: false },
  { to: "https://linktr.ee/LyonsDenProtection", label: "Original Linktree", icon: ExternalLink, internal: false },
];

export default function SocialHub() {
  return (
    <div className="py-16 md:py-24 px-6 max-w-2xl mx-auto" data-testid="social-hub-page">
      <div className="text-center">
        <LionLogo size={120} className="mx-auto" />
        <h1 className="font-serif text-3xl md:text-4xl mt-6">Lyon's Den Protection</h1>
        <div className="overline mt-2 text-[#D4AF37]">@lyonsdenprotection</div>
        <p className="mt-4 text-white/70 italic font-serif text-lg">Shielded By Fire. Guarded By Spirit.</p>
      </div>

      <div className="mt-12 space-y-3" data-testid="social-hub-links">
        {LINKS.map((l, i) => {
          const Icon = l.icon;
          const cls = "flex items-center justify-between border border-white/15 hover:border-[#D4AF37] hover:bg-[#D4AF37]/5 px-6 py-4 transition-colors group";
          const content = (
            <>
              <span className="flex items-center gap-3"><Icon size={18} className="text-[#D4AF37]" />{l.label}</span>
              <ExternalLink size={14} className="text-white/30 group-hover:text-[#D4AF37]" />
            </>
          );
          return l.internal ? (
            <Link key={i} to={l.to} className={cls} data-testid={`social-link-${i}`}>{content}</Link>
          ) : (
            <a key={i} href={l.to} target="_blank" rel="noreferrer" className={cls} data-testid={`social-link-${i}`}>{content}</a>
          );
        })}
      </div>
    </div>
  );
}
